import formatStringByPattern from 'format-string-by-pattern';
import {
 composeValidators,
 isCorrectPasswordLength,
 isCorrectPesel,
 isPhoneNumber,
 isRequired,
 optionalEmailValidator,
} from '../../helpers';

import { communicationLanguages, userRolesLocales } from '../userRoles';

export const userForm = [
 {
  name: 'login',
  placeholder: 'entriesForms.loginPlaceholder',
  type: 'text',
  component: 'input',
  validate: isRequired,
  autoComplete: 'username',
 },
 {
  name: 'password',
  placeholder: 'entriesForms.passwordPlaceholder',
  type: 'password',
  component: 'input',
  autoComplete: 'current-password',
  validate: composeValidators(isRequired, isCorrectPasswordLength),
 },
];

export const orserCallForm = [
 {
  name: 'name',
  placeholder: 'entriesForms.firstNamePlaceholder',
  type: 'text',
  component: 'input',
  validate: isRequired,
 },
 {
  name: 'phoneNumber',
  placeholder: 'entriesForms.phonePlaceholder',
  type: 'tel',
  component: 'input',
  validate: composeValidators(isRequired, isPhoneNumber),
 },
];

export const userFormSignUp = [
 {
  name: 'firstName',
  placeholder: 'entriesForms.firstNamePlaceholder',
  type: 'text',
  component: 'input',
  validate: isRequired,
 },
 {
  name: 'lastName',
  placeholder: 'entriesForms.lastNamePlaceholder',
  type: 'text',
  component: 'input',
  validate: isRequired,
 },
 {
  name: 'phoneNumber',
  placeholder: 'entriesForms.phonePlaceholder',
  type: 'tel',
  component: 'input',
  validate: composeValidators(isRequired, isPhoneNumber),
  // parse: formatStringByPattern(phoneMask),
 },
 {
  name: 'email',
  placeholder: 'entriesForms.emailPlaceholder',
  type: 'text',
  component: 'input',
  validate: optionalEmailValidator,
 },
 {
  name: 'idCode',
  placeholder: 'entriesForms.idCodePlaceholder',
  type: 'text',
  validate: isCorrectPesel,
  component: 'input',
  autoComplete: 'id-code',
  parse: formatStringByPattern('99999999999'),
 },
 {
  name: 'password',
  placeholder: 'entriesForms.passwordPlaceholder',
  type: 'password',
  component: 'input',
  autoComplete: 'new-password',
  validate: composeValidators(isRequired, isCorrectPasswordLength),
 },
 {
  name: 'isPolicyAccepted',
  label: 'entriesForms.policyLabel',
  component: 'input',
  type: 'checkbox',
  validate: isRequired,
 },
];

export const adminCreateUserForm = [
 {
  name: 'firstName',
  placeholder: 'adminPanel.form.firstNamePlaceholder',
  label: 'adminPanel.form.firstNameLabel',
  type: 'text',
  component: 'input',
  validate: isRequired,
 },
 {
  name: 'lastName',
  placeholder: 'adminPanel.form.lastNamePlaceholder',
  label: 'adminPanel.form.lastNameLabel',
  type: 'text',
  component: 'input',
  validate: isRequired,
 },
 {
  name: 'role',
  label: 'adminPanel.form.userTypeLabel',
  component: 'select',
  options: userRolesLocales,
 },
 {
  name: 'phoneNumber',
  placeholder: 'adminPanel.form.phonePlaceholder',
  label: 'adminPanel.form.phoneLabel',
  type: 'tel',
  component: 'input',
  validate: composeValidators(isRequired, isPhoneNumber),
  // parse: formatStringByPattern(phoneMask),
 },
 {
  name: 'email',
  placeholder: 'adminPanel.form.emailPlaceholder',
  label: 'adminPanel.form.emailLabel',
  type: 'text',
  component: 'input',
  validate: optionalEmailValidator,
 },
 {
  name: 'idCode',
  placeholder: 'adminPanel.form.idCodePlaceholder',
  label: 'adminPanel.form.idCodeLabel',
  type: 'text',
  validate: isCorrectPesel,
  component: 'input',
  parse: formatStringByPattern('99999999999'),
 },
 {
  name: 'city',
  placeholder: 'adminPanel.form.cityPlaceholder',
  label: 'adminPanel.form.cityLabel',
  type: 'text',
  component: 'input',
 },
 {
  name: 'street',
  placeholder: 'adminPanel.form.streetPlaceholder',
  label: 'adminPanel.form.streetLabel',
  type: 'text',
  component: 'input',
 },
 {
  name: 'language',
  label: 'adminPanel.form.communicationLanguage',
  component: 'select',
  options: communicationLanguages,
 },
 {
  name: 'Photo',
  placeholder: 'adminPanel.form.photoLabel',
  label: 'adminPanel.form.photoLabel',
  type: 'file',
 },
];

export const adminUserProfileForm = [
 {
  name: 'firstName',
  placeholder: 'adminPanel.form.firstNamePlaceholder',
  label: 'adminPanel.form.firstNameLabel',
  type: 'text',
  component: 'input',
  validate: isRequired,
 },
 {
  name: 'lastName',
  placeholder: 'adminPanel.form.lastNamePlaceholder',
  label: 'adminPanel.form.lastNameLabel',
  type: 'text',
  component: 'input',
  validate: isRequired,
 },

 {
  name: 'phoneNumber',
  placeholder: 'adminPanel.form.phonePlaceholder',
  label: 'adminPanel.form.phoneLabel',
  type: 'tel',
  component: 'input',
  validate: composeValidators(isRequired, isPhoneNumber),
  // parse: formatStringByPattern(phoneMask),
 },
 {
  name: 'email',
  placeholder: 'adminPanel.form.emailPlaceholder',
  label: 'adminPanel.form.emailLabel',
  type: 'text',
  component: 'input',
  validate: optionalEmailValidator,
 },
 {
  name: 'city',
  placeholder: 'adminPanel.form.cityPlaceholder',
  label: 'adminPanel.form.cityLabel',
  type: 'text',
  component: 'input',
 },
 {
  name: 'street',
  placeholder: 'adminPanel.form.streetPlaceholder',
  label: 'adminPanel.form.streetLabel',
  type: 'text',
  component: 'input',
 },
 {
  name: 'idCode',
  placeholder: 'adminPanel.form.idCodePlaceholder',
  label: 'adminPanel.form.idCodeLabel',
  type: 'text',
  validate: isCorrectPesel,
  component: 'input',
  parse: formatStringByPattern('99999999999'),
 },
 {
  name: 'language',
  label: 'adminPanel.form.communicationLanguage',
  component: 'select',
  options: communicationLanguages,
 },
];

export const adminUpdatePatientForm = [
 {
  name: 'firstName',
  placeholder: 'adminPanel.form.firstNamePlaceholder',
  label: 'adminPanel.form.firstNameLabel',
  type: 'text',
  component: 'input',
  validate: isRequired,
 },
 {
  name: 'lastName',
  placeholder: 'adminPanel.form.lastNamePlaceholder',
  label: 'adminPanel.form.lastNameLabel',
  type: 'text',
  component: 'input',
  validate: isRequired,
 },
 {
  name: 'email',
  placeholder: 'adminPanel.form.emailPlaceholder',
  label: 'adminPanel.form.emailLabel',
  type: 'text',
  component: 'input',
  validate: optionalEmailValidator,
 },
 {
  name: 'phoneNumber',
  placeholder: 'adminPanel.form.phonePlaceholder',
  label: 'adminPanel.form.phoneLabel',
  type: 'tel',
  component: 'input',
  validate: composeValidators(isRequired, isPhoneNumber),
 },
 {
  name: 'city',
  placeholder: 'adminPanel.form.cityPlaceholder',
  label: 'adminPanel.form.cityLabel',
  type: 'text',
  component: 'input',
 },
 {
  name: 'street',
  placeholder: 'adminPanel.form.streetPlaceholder',
  label: 'adminPanel.form.streetLabel',
  type: 'text',
  component: 'input',
 },
 {
  name: 'idCode',
  placeholder: 'adminPanel.form.idCodePlaceholder',
  label: 'adminPanel.form.idCodeLabel',
  type: 'text',
  validate: isCorrectPesel,
  component: 'input',
  parse: formatStringByPattern('99999999999'),
 },
 {
  name: 'language',
  label: 'adminPanel.form.communicationLanguage',
  component: 'select',
  options: communicationLanguages,
 },
];

export const userChangePasswordForm = [
 {
  name: 'oldPassword',
  placeholder: 'entriesForms.oldPasswordPlaceholder',
  type: 'password',
  component: 'input',
  validate: composeValidators(isRequired, isCorrectPasswordLength),
 },
 {
  name: 'password',
  placeholder: 'entriesForms.newPasswordPlaceholder',
  type: 'password',
  component: 'input',
  validate: composeValidators(isRequired, isCorrectPasswordLength),
 },
 {
  name: 'confirmPassword',
  placeholder: 'entriesForms.confirmNewPasswordPlaceholder',
  type: 'password',
  component: 'input',
  validate: composeValidators(isRequired, isCorrectPasswordLength),
 },
];
